module.exports = __webpack_public_path__ + "static/google-sheets-export-31ae6b977bf4348d934d8542100c1131.svg";